import { Component, Input } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';

/**
 * Positionen des Termin-Tooltips im CDK-Overlay: bevorzugt oberhalb, sonst unterhalb.
 * Zusammen mit cdkConnectedOverlayPush und ViewportMargin bleibt der Tooltip auch am
 * rechten/unteren Rand vollständig sichtbar (das Overlay liegt außerhalb des Kalenders).
 */
export const RESOURCE_TOOLTIP_POSITIONS: ConnectedPosition[] = [
  { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -10 },
  { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 10 }
];

/**
 * Inhalt des Termin-Tooltips der Ressourcenplanung (Teamplanung und „Mein Kalender“).
 * Ursprünglich direkt in der Teamplanung umgesetzt, hierher ausgelagert, damit beide
 * Ansichten denselben Tooltip verwenden. Wird innerhalb eines cdkConnectedOverlay
 * angezeigt; nimmt keine Mausereignisse an (kein Flackern beim Bewegen der Maus).
 */
@Component({
  selector: 'app-resource-assignment-tooltip',
  templateUrl: './resource-assignment-tooltip.component.html',
  styleUrls: ['./resource-assignment-tooltip.component.css']
})
export class ResourceAssignmentTooltipComponent {
  /** Typ bzw. Kategorie, z. B. „Outlook-Termin“ oder der Kategoriename. */
  @Input() category = '';
  @Input() title = '';
  /** yyyy-MM-dd */
  @Input() startDate = '';
  @Input() endDate = '';
  /** HH:mm */
  @Input() startTime = '';
  @Input() endTime = '';
  /** Ganztägig: statt Uhrzeiten „Ganztägig“. */
  @Input() allDay = false;
  /** Zeitraum immer als Bereich anzeigen (Jahresansicht der Teamplanung). */
  @Input() alwaysShowRange = false;
  @Input() utilizationPercent: number | null = null;
  @Input() participants: string | null = null;
  @Input() location: string | null = null;
  /** Statusbereich unten (z. B. „Noch nicht in die Planung übernommen“). */
  @Input() footerText: string | null = null;
  @Input() footerIcon = 'info_outline';

  get singleDay(): boolean {
    return !this.alwaysShowRange && this.startDate === this.endDate;
  }
}
